module.exports = __webpack_public_path__ + "static/media/loading-white-ico.64e0df7e.svg";